import moment from "moment";
import { FlexRow } from "src/utils/flexLayouts";
import { useSearchParams } from "react-router-dom";

interface IIncidentBanerProps {
  lastInc: any;
}

const IncidentBaner: React.FC<IIncidentBanerProps> = ({ lastInc }) => {

  const [query, setQuery] = useSearchParams();

  const openDocumentCard = (id: number) => {
    const newSearchParams = new URLSearchParams(query);
    newSearchParams.set("incidentCard", id.toString());
    setQuery(newSearchParams);
  }

  return (
    <div className="w-[350px] h-[56px] bg-[#FFE7E7] rounded-lg pt-2">
      <div className="flex items-center gap-x-2 px-4">
        <span className="text-[#DC2626] text-[32px] leading-[40px] font-bold">
          {moment(new Date).startOf('day').diff(moment(lastInc.DateIncidents2).startOf('day'), 'days')}
        </span>
        <div className="flex flex-col">
          <span className="text-[#111928] font-inter text-xs font-normal leading-4 whitespace-nowrap">
            Дней без травм с потерей трудоспособности
          </span>
          <FlexRow
            onClick={() => openDocumentCard(lastInc.ID)}
            className="text-[#012169] font-inter text-xs font-medium leading-4 underline underline-offset-[auto] decoration-solid decoration-from-font whitespace-nowrap cursor-pointer"
          >
            Последний инцидент {moment(lastInc.DateIncidents2).format('DD.MM.YYYY')}
          </FlexRow>
        </div>
      </div>
    </div>
  );
}

export default IncidentBaner

